import { fetchWrapper } from '@/_helpers';

const PUBLIC_BASE_URL = 'real-estate/public';
const ADMIN_BASE_URL = 'real-estate';

export const realEstateListingsApi = {
    getPublicListings: ({ page = 1, limit = 50, searchText = '', ...filters } = {}) => {
        const params = new URLSearchParams();
        if (page) params.append('page', page);
        if (limit) params.append('limit', limit);
        if (searchText) params.append('searchText', searchText);
        if (filters.propertyType) params.append('propertyType', filters.propertyType);
        if (filters.minPrice != null) params.append('minPrice', filters.minPrice);
        if (filters.maxPrice != null) params.append('maxPrice', filters.maxPrice);
        if (filters.opportunityZone) params.append('opportunityZone', 'true');
        if (filters.zoning) params.append('zoning', filters.zoning);
        if (filters.pipelineStage) params.append('pipelineStage', filters.pipelineStage);
        return fetchWrapper.get(`${PUBLIC_BASE_URL}/properties?${params.toString()}`);
    },
    getNearbyProperties: ({ lat, lng, radius = 2 } = {}) => {
        const params = new URLSearchParams();
        params.append('lat', lat);
        params.append('lng', lng);
        params.append('radius', radius);
        return fetchWrapper.get(`${PUBLIC_BASE_URL}/properties-nearby?${params.toString()}`);
    },
    getPropertiesNearVisits: ({ daysBack = 30, radius = 2 } = {}) => {
        const params = new URLSearchParams();
        params.append('daysBack', daysBack);
        params.append('radius', radius);
        return fetchWrapper.get(`${PUBLIC_BASE_URL}/properties-near-visits?${params.toString()}`);
    },
    ensurePropertyChannels: (propertyIds) => {
        return fetchWrapper.post(`${PUBLIC_BASE_URL}/channels`, { propertyIds });
    },
    setPropertyLabel: (propertyId, label) => {
        return fetchWrapper.patch(`${ADMIN_BASE_URL}/properties/${propertyId}/label`, { label });
    },
    RE_LABELS: {
        interested: '#2d8a4e',
        researching: '#f59e0b',
        offer_ready: '#1a73e8',
        watchlist: '#7b2cbf',
        pass: '#6c757d',
        acquired: '#198754',
    },
    RE_LABEL_OPTIONS: [
        { value: '', label: 'No Label' },
        { value: 'interested', label: 'Interested' },
        { value: 'researching', label: 'Researching' },
        { value: 'offer_ready', label: 'Offer Ready' },
        { value: 'watchlist', label: 'Watchlist' },
        { value: 'pass', label: 'Pass' },
        { value: 'acquired', label: 'Acquired' },
    ],
};
